/* eslint-disable import/first */
import type { ReactNode, ReactElement } from 'react';

import { forwardRef } from 'react';
import type { ForwardedRef } from 'react';
// material
import { alpha, useTheme } from '@mui/material/styles';
import { IconButton } from '@mui/material';
//
import { ButtonAnimate } from '../animate';

const IconButtonComponent = IconButton as any;

export interface MIconButtonProps {
  children?: ReactNode;
  sx?: Record<string, any>;
  color?: string;
  [key: string]: any;
}

// ----------------------------------------------------------------------

const MIconButton = forwardRef(function MIconButtonImpl(
  { color = 'default', children, sx, ...other }: MIconButtonProps,
  ref: ForwardedRef<HTMLElement>
) {
  const theme = useTheme();

  if (
    color === 'default' ||
    color === 'inherit' ||
    color === 'primary' ||
    color === 'secondary'
  ) {
    return (
      <ButtonAnimate>
        <IconButtonComponent
          ref={ref}
          color={color}
          sx={sx}
          {...other}
          size="large"
        >
          {children}
        </IconButtonComponent>
      </ButtonAnimate>
    );
  }

  return (
    <ButtonAnimate>
      <IconButtonComponent
        ref={ref}
        sx={{
          color: theme.palette[color].main,
          '&:hover': {
            bgcolor: alpha(
              theme.palette[color].main,
              theme.palette.action.hoverOpacity
            ),
          },
          ...sx,
        }}
        {...other}
        size="large"
      >
        {children}
      </IconButtonComponent>
    </ButtonAnimate>
  );
});

export default MIconButton;
